<template>
  <div class="pr-2 pt-2" v-if="user.type != 'guest'">
    <router-link
      :to="{
        name:
          company?.type === 'group'
            ? 'category-menu'
            : hasGroupGoodMenu(company)
            ? 'category-menu-add'
            : 'company-menu',
      }"
    >
      <img
        id="ordera_logo"
        style="width: 50px"
        :src="'https://restorani.bitlab.host/img/o.png'"
        alt="image"
      />
    </router-link>
  </div>
  <div v-else class="pr-2">
    <a href="/#/guest">
      <img
        style="width: 110px"
        :src="'https://app.restorani.bitlab.host/gallery/logo.png'"
        alt="image"
      />
    </a>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "AppLogo",
  computed: {
    ...mapState(['user', 'company']),
  },
  methods: {
    hasGroupGoodMenu(companies) {
      if (companies && companies.type === "group_food") {
        return true;
      }
    },
  },
};
</script>
